/* Delegation also supports native Impulse variant/section re-rendering. */
(() => {
  async function estimate(container) {
    const input = container.querySelector('[data-shipping-cep]');
    const result = container.querySelector('[data-shipping-result]');
    const button = container.querySelector('[data-shipping-check]');
    const cep = input.value.replace(/\D/g, '');
    if (cep.length !== 8) { result.textContent = 'Digite um CEP válido com 8 números.'; return; }
    button.disabled = true;
    result.textContent = 'Consultando CEP…';
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, {signal: AbortSignal.timeout(10000)});
      if (!response.ok) throw new Error('CEP service unavailable');
      const data = await response.json();
      if (data.erro) { result.textContent = 'CEP não encontrado. Confira os números e tente novamente.'; return; }
      const start = new Date(), end = new Date();
      start.setDate(start.getDate() + 7); end.setDate(end.getDate() + 15);
      const format = d => d.toLocaleDateString('pt-BR', {day:'2-digit',month:'long'});
      result.replaceChildren();
      const city = document.createElement('strong');
      city.textContent = `${data.localidade} — ${data.uf}`;
      const delivery = document.createElement('p');
      delivery.textContent = `Frete grátis. Estimativa entre ${format(start)} e ${format(end)}.`;
      const note = document.createElement('small');
      note.textContent = 'Estimativa baseada no prazo padrão. Confira o prazo e as condições finais no checkout.';
      result.append(city, delivery, note);
    } catch (_) {
      result.textContent = 'Não foi possível consultar o CEP agora. Você poderá confirmar a entrega no checkout.';
    } finally { button.disabled = false; }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-shipping-check]');
    if (button) { event.preventDefault(); estimate(button.closest('[data-milano-shipping]')); }
  });
  document.addEventListener('keydown', event => {
    if(event.key === 'Enter' && event.target.matches('[data-shipping-cep]')) {
      event.preventDefault(); estimate(event.target.closest('[data-milano-shipping]'));
    }
  });
})();
